module.exports = __webpack_public_path__ + "img/ricelog_pinicon_071.c36b0682.png";